import React from 'react';

import { FormattedMessage } from 'react-intl';
import { di } from 'react-magnetic-di';

import Heading from '@atlaskit/heading/heading';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { VisibilityFieldSet } from '../../../common/types/form';
import { getSectionVisibilityMap } from '../../../common/utils/sections/conditions';
import { useCurrentValues, useFormRendererState } from '../../../controllers/form-renderer-store';
import { FormSection } from './form-section';
import { messages } from './messages';

const hiddenSectionContainerStyles = xcss({
	position: 'relative',
	padding: 'space.050',
});

const hiddenSectionWrapperStyles = xcss({
	height: '100%',
	width: '100%',
	backgroundColor: 'color.background.disabled',
	top: 'space.0',
	left: 'space.0',
	position: 'absolute',
	borderRadius: 'radius.small',
	textAlign: 'center',
	pointerEvents: 'none',
});

const hiddenSectionOverlayStyles = xcss({
	padding: 'space.100',
	color: 'color.text',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
	backgroundColor: 'color.background.accent.gray.subtler',
	display: 'inline-block',
	position: 'relative',
	top: 'space.100',
	borderRadius: 'radius.large',
});

export const FormSections = (): React.JSX.Element => {
	di();

	const {
		fieldVisibility,
		formFields,
		formId,
		formSections: allFormSections,
	} = useFormRendererState();
	const currentValues = useCurrentValues();
	const sectionVisibilityMap = getSectionVisibilityMap(allFormSections, formFields, currentValues);

	const formSections = allFormSections;

	return (
		<>
			{formSections.map((section, index) => {
				const sectionIsVisible = sectionVisibilityMap?.get(index) ?? false;

				if (
					fieldVisibility.fieldSet?.length === 0 ||
					(!sectionIsVisible && !fieldVisibility.fieldSet.includes(VisibilityFieldSet.ALL_FIELDS))
				) {
					return null;
				}

				if (!sectionIsVisible && fieldVisibility.fieldSet.includes(VisibilityFieldSet.ALL_FIELDS)) {
					return (
						<Box
							key={`pf-${formId}-form-section-${index.toString()}`}
							xcss={hiddenSectionContainerStyles}
						>
							<FormSection
								key={`pf-${formId}-form-section-${index.toString()}`}
								sectionKey={index.toString()}
								sectionLayout={section.layout}
							/>
							<Box xcss={hiddenSectionWrapperStyles}>
								<Box xcss={hiddenSectionOverlayStyles}>
									<Heading size="small">
										<FormattedMessage {...messages.hiddenSectionTitle} />
									</Heading>
								</Box>
							</Box>
						</Box>
					);
				}

				return (
					<FormSection
						key={`pf-${formId}-form-section-${index.toString()}`}
						sectionKey={index.toString()}
						sectionLayout={section.layout}
					/>
				);
			})}
		</>
	);
};
